import { useMemo, useCallback } from 'react';
import { debounce } from 'throttle-debounce';

function useDebouncedSetState(delay, setState) {
    var debouncedSetState = useMemo(function() {
        return debounce(delay, false, function(value) {
            return setState(value);
        });
    }, [
        delay,
        setState
    ]);
    return useCallback(debouncedSetState, [
        debouncedSetState,
        delay,
        setState
    ]);
}

export { useDebouncedSetState };
